module.exports = " <router-view keep-alive></router-view> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 21
 ** module chunks = 2
 **/